import React from "react";

import ArrowRight from "../Icons/ArrowRightShape";
import CompanyLogoOutlined from "../CompanyLogoOutlined/CompanyLogoOutlined";

import styles from "./JobRecommendationCard.module.scss";

interface JobRecommendationCardClasses {
    jobRecommendationCard?: string;
    link?: string;
    container?: string;
    logoPill?: string;
    content?: string;
    companyName?: string;
    jobTitle?: string;
    footer?: string;
    location?: string;
    viewJob?: string;
    tooltip?: string;
    tooltipContainer?: string;
    tooltipCompany?: string;
    tooltipTitle?: string;
    tooltipLocation?: string;
}

interface JobRecommendationCardProps {
    classes?: JobRecommendationCardClasses;
    companyName: string;
    jobTitle: string;
    location: string;
    companyLogoUrl: string;
    jobUrl: string;
    onClick?: () => void;
}

const JobRecommendationCard = (props: JobRecommendationCardProps) => {
    const {
        classes, companyName, jobTitle, location, companyLogoUrl, jobUrl, onClick
    } = props;

    const enableTooltip = companyName.length >= 35 || jobTitle.length >= 35;

    return (
        <div className={classes?.jobRecommendationCard || styles.jobRecommendationCard}>
            <a
                href={jobUrl}
                onClick={onClick}
                className={classes?.link || styles.link}
            >
                <div className={classes?.container || styles.container}>
                    <CompanyLogoOutlined
                        altText={`${companyName} Logo`}
                        className={classes?.logoPill || styles.logoPill}
                        logoUrl={companyLogoUrl}
                    />
                    <div className={classes?.content || styles.content}>
                        <div className={classes?.companyName || styles.companyName}>{companyName}</div>
                        <div className={classes?.jobTitle || styles.jobTitle}>{jobTitle}</div>
                        <div className={classes?.footer || styles.footer}>
                            <div className={classes?.location || styles.location}>{location}</div>
                            <div className={classes?.viewJob || styles.viewJob}>
                                {"View Job "}
                                <ArrowRight height={16} />
                            </div>
                        </div>
                        {enableTooltip ? (
                            <span className={classes?.tooltip || styles.tooltip} role="tooltip">
                                <div className={classes?.tooltipContainer || styles.tooltipContainer}>
                                    <div className={classes?.tooltipCompany || styles.tooltipCompany}>
                                        {companyName}
                                    </div>
                                    <div className={classes?.tooltipTitle || styles.tooltipTitle}>{jobTitle}</div>
                                    <div className={classes?.tooltipLocation || styles.tooltipLocation}>{location}</div>
                                </div>
                            </span>
                        ) : null}
                    </div>
                </div>
            </a>
        </div>
    );
};

export { JobRecommendationCard as default };
export type { JobRecommendationCardProps };
